import { render } from "./RedPackage.vue?vue&type=template&id=c2f54106&scoped=true"
import script from "./RedPackage.vue?vue&type=script&lang=ts"
export * from "./RedPackage.vue?vue&type=script&lang=ts"

import "./RedPackage.vue?vue&type=style&index=0&id=c2f54106&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2f54106"

export default script